import React, { Fragment } from 'react';

/*
 * Import Assets
 */
import Bomber from '../../assets/img/mapDecoration/Bomber.png';

class Radiator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      explode: false,
    };
  }

  render() {
    return (
      <Fragment>
        <img
          src={Bomber}
          className={'bomber'}
          alt={'Bomber'}/>
      </Fragment>
    )
  }
}

export default Radiator;




// WEBPACK FOOTER //
// ./src/components/elements/Radiation.js